var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFilledTrue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8887 11.7667C14.0827 11.5727 14.0827 11.2537 13.8887 11.0597C13.6947 10.8647 13.3757 10.8647 13.1817 11.0597L10.4997 13.7417L10.4997 5.05171C10.4997 4.77671 10.2747 4.55171 9.99968 4.55171C9.72468 4.55171 9.49968 4.77671 9.49968 5.05171L9.49968 13.7417L6.81768 11.0597C6.62268 10.8647 6.30468 10.8647 6.11068 11.0597C5.91568 11.2537 5.91568 11.5727 6.11068 11.7667L9.64568 15.3027C9.84068 15.4967 10.1587 15.4967 10.3527 15.3027L13.8887 11.7667Z",
    fill: "#00A0AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 -3.91392e-07 10 -8.74228e-07C4.477 -1.35706e-06 1.35706e-06 4.477 8.74228e-07 10C3.91392e-07 15.523 4.477 20 10 20M10 19C5.037 19 1 14.963 1 10C1 5.037 5.037 0.999999 10 0.999999C14.963 1 19 5.037 19 10C19 14.963 14.963 19 10 19",
    fill: "#00A0AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8887 11.7667C14.0827 11.5727 14.0827 11.2537 13.8887 11.0597C13.6947 10.8647 13.3757 10.8647 13.1817 11.0597L10.4997 13.7417L10.4997 5.05171C10.4997 4.77671 10.2747 4.55171 9.99968 4.55171C9.72468 4.55171 9.49968 4.77671 9.49968 5.05171L9.49968 13.7417L6.81768 11.0597C6.62268 10.8647 6.30468 10.8647 6.11068 11.0597C5.91568 11.2537 5.91568 11.5727 6.11068 11.7667L9.64568 15.3027C9.84068 15.4967 10.1587 15.4967 10.3527 15.3027L13.8887 11.7667Z",
    fill: "#00A0AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 -3.91392e-07 10 -8.74228e-07C4.477 -1.35706e-06 1.35706e-06 4.477 8.74228e-07 10C3.91392e-07 15.523 4.477 20 10 20M10 19C5.037 19 1 14.963 1 10C1 5.037 5.037 0.999999 10 0.999999C14.963 1 19 5.037 19 10C19 14.963 14.963 19 10 19",
    fill: "#00A0AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFilledTrue);
export default __webpack_public_path__ + "static/media/Download_Filled_True.9b484f7c2f1180e235c35b1737f3aef8.svg";
export { ForwardRef as ReactComponent };